import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import PopupVideo from '../popup/video/popup-video';
import Form from '../form/form';
import BaseSlider from '../baseSlider/baseSlider';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const section = document.querySelectorAll('.sectionObject');

  if (section && section.length) {
    [].slice.call(section).forEach((item) => {
      const object = window.sectionObjectData;
      window.VueEvent = new Vue();
      new Vue({
        el: item,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          sectionForm: Form(window.sectionObjectData.form),
          PopupFullscreen,
          PopupVideo,
          BaseSlider,
        },
        data() {
          return {
            sectionObjectData: object,
            mainSlider: null,
            thumbsSlider: null,
            popupFullOpen: false,
            fullscreenActive: 0,
            fullscreenCards: [],
            isDescrShow: false,
            count: object.count || 0,
            popupVideoOpen: false,
            popupVideoData: '',
          };
        },
        mounted() {
          // this.slidersInit();
        },
        methods: {
          slidersInit() {
            this.thumbsSlider = new Swiper(this.$el.querySelector('.location__thumb-slider'), {
              slideToClickedSlide: true,
              slidesPerView: 'auto',
            });

            const thumbs = this.thumbsSlider;

            this.mainSlider = new Swiper(this.$el.querySelector('.location__main-slider'), {
              slidesPerView: 1,
              navigation: {
                nextEl: '.sliderButtons__btn--next',
                prevEl: '.sliderButtons__btn--prev',
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  if (this.slides.length <= 1) {
                    if (this.$el.querySelector('.location__slider-btns')) {
                      this.$el.querySelector('.location__slider-btns').style.display = 'none';
                    }
                  }
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    if (slides) {
                      slides.forEach(tmp => tmp.classList.remove('location__thumb-slide--active'));
                      slides[this.realIndex].classList.add('location__thumb-slide--active');
                    }
                    thumbs.slideTo(this.realIndex);
                  }
                },
                slideChange() {
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    slides.forEach(tmp => tmp.classList.remove('location__thumb-slide--active'));
                    slides[this.realIndex].classList.add('location__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            });

            this.mainSlider.params.controller.control = this.thumbsSlider;
            this.thumbsSlider.params.controller.control = this.mainSlider;
          },

          openFullPopup(data) {
            this.fullscreenCards = data.cards;
            this.fullscreenActive = data.active;
            const popup = this.$el.querySelector('.popup-fullscreen');
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },

          openVideo(data) {
            this.popupVideoOpen = true;
            if (data) {
              this.popupVideoData = data;
            }
          },

          declOfNum(number, words) {
            return words[(number % 100 > 4 && number % 100 < 20) ?
              2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ?
                number % 10 : 5]];
          },
        },
        computed: {
          declensionText() {
            return this.declOfNum(this.count, ['клиент', 'клиента', 'клиентов']);
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./blocks/sectionObject/sectionObject.js